<template>
    <div class="empty-pot">
        No {{ name }} added.
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EmptyAsset",
  props: {
    name: { type: String, required: true }
  }
});
</script>

<style scoped>
    .empty-pot {
        border: 1px dashed #ccc;
        border-radius: 4px;
        text-align: center;
        margin-bottom: 15px;
        padding: 15px;
    }
</style>
